(function () {
  const quizMap = {
    en: "2902",
    lt: "2930",
    lv: "2987",
    ee: "2988",
    et: "2988",
    ru: "2989"
  };

  function getLocale() {
    // Shopify dažniausiai turi <html lang="en"> arba "lt", "lv", etc.
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    const short = htmlLang.split("-")[0]; // pvz. lt-LT -> lt
    return quizMap[short] ? short : "en";
  }

  function swapQuizIframe(iframe) {
    const src = iframe.getAttribute("src") || "";
    if (!src.includes("quiz-builder-24wuu.ondigitalocean.app/quiz/")) return;

    const locale = getLocale();
    const quizId = quizMap[locale];

    // pakeičiam ID tarp /.../XXXX? (pvz. /2902?cid=)
    const newSrc = src.replace(/\/(\d+)\?/, `/${quizId}?`);
    if (newSrc !== src) iframe.setAttribute("src", newSrc);
  }

  function trySwap() {
    document.querySelectorAll("iframe").forEach(swapQuizIframe);
  }

  // 1) bandome iškart
  document.addEventListener("DOMContentLoaded", trySwap);

  // 2) stebim, nes app block iframe kartais įsideda vėliau
  const obs = new MutationObserver(() => trySwap());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
